"use client"
/* */
const locales = {"de-DE": {  "list.filters": `Filter`,
  "list.filters.clear": `Filter entfernen`,
  "list.filters.reset": `Filter zurücksetzen`,
  "list.filters.store": `Filter speichern`,
  "list.noResult.heading": `Keine Suchergebnisse gefunden`,
  "list.noResult.text": `Deine Suche ergab keine Ergebnisse. Bitte passe die Suchanfrage oder deine Filter an.`,
  "list.options": `Optionen`,
  "list.paginationInfo": (args) => `${args.visibleItemsCount} von insgesamt ${args.totalItemsCount} angezeigt`,
  "list.settings": `Einstellungen`,
  "list.settings.viewMode": `Ansicht`,
  "list.settings.viewMode.list": `Liste`,
  "list.settings.viewMode.table": `Tabelle`,
  "list.settings.viewMode.tiles": `Raster`,
  "list.showMore": `Mehr anzeigen`,
  "list.sorting": `Sortierung`,
  "list.toggleExpandButton.collapse": `Weniger anzeigen`,
  "list.toggleExpandButton.expand": `Mehr anzeigen`,
},"en-US": {  "list.filters": `Filters`,
  "list.filters.clear": `Clear filters`,
  "list.filters.reset": `Reset filters`,
  "list.filters.store": `Store filters`,
  "list.noResult.heading": `No search results found`,
  "list.noResult.text": `Your search did not return any results. Please adjust the search query or your filters.`,
  "list.options": `Options`,
  "list.paginationInfo": (args) => `Showing ${args.visibleItemsCount} of ${args.totalItemsCount}`,
  "list.settings": `Settings`,
  "list.settings.viewMode": `View`,
  "list.settings.viewMode.list": `List`,
  "list.settings.viewMode.table": `Table`,
  "list.settings.viewMode.tiles": `Tiles`,
  "list.showMore": `Show more`,
  "list.sorting": `Sorting`,
  "list.toggleExpandButton.collapse": `Show less`,
  "list.toggleExpandButton.expand": `Show more`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs.map
